<script setup>
import { computed, ref } from 'vue';
import NinaStandalone from '../crm/nina/NinaStandalone.vue';
import CloserQuoteLeadSearch from '../crm/nina/CloserQuoteLeadSearch.vue';

defineEmits(['close']);

const standaloneRef = ref(null);
const hasDomain = computed(() => Boolean(standaloneRef.value?.domain));

</script>

<template>
    <slideout-with-slots
        max-width-class="max-w-5xl"
        :resizeable="true"
        @close="$emit('close')"
    >
        <template #title>
            <div>
                <h1 class="text-lg font-semibold">Closer</h1>
                <p v-if="standaloneRef?.domain" class="text-sm opacity-80">{{ standaloneRef.domain }}</p>
            </div>
        </template>

        <template #body>
            <div class="flex flex-col h-screen">
                <div :class="hasDomain ? '' : 'grid gap-4 md:grid-cols-2'">
                    <div :class="hasDomain ? '' : 'flex flex-col px-4 bg-white border border-gray-200 rounded-xl'">
                        <nina-standalone
                            ref="standaloneRef"
                            :initial-message="initialMessage"
                        />
                    </div>
                    <div v-if="!hasDomain" class="flex flex-col px-4 bg-white border border-gray-200 rounded-xl">
                        <closer-quote-lead-search />
                    </div>
                </div>
            </div>
        </template>
    </slideout-with-slots>
</template>
